module.exports = __webpack_public_path__ + "static/explorers_pack-ef2e997ea2f3136a347128b9bc11b16b.jpg";